import { withInstall } from '@zoryn/utils'
import Progress from './src/progress.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZProgress: SFCWithInstall<typeof Progress> = withInstall(Progress)
export default ZProgress

export * from './src/progress'
